<div class="header">
  @if (integrationsListOptions.length > 0) {
    <app-select
      class="header-integrations"
      [placeHolder]="'violationRulesPage.selectIntegrationPlaceHolder' | labelsProvider"
      [options]="integrationsListOptions"
      [clearSelectionObservable]="clearIntegrationSelection$"
      [optionSelectObservable]="integrationSelectedOption$"
      [newOptionObservable]="integrationNewOptions$"
      (optionOnSelection)="onIntegrationSelectedFromIntegrationList($event)"
    >
    </app-select>
  }

  @if ((isLoading$ | async) === false) {
    <app-button
      [isEnabled]="!reachedMaxNumberOfPolicies && !disabledAddPolicyButtonReason"
      buttonIconPath="assets/images/common/plus.svg"
      tooltipPosition="left"
      [disabledTooltipText]="disabledAddPolicyButtonReason"
      (buttonClicked)="addPolicyClicked()"
      buttonTextLabelPath="policyPage.addPolicy"
    >
    </app-button>
  }
</div>

@if (isLoading$ | async) {
  <div class="spinner">
    <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
  </div>
}

@if ((isLoading$ | async) === false) {
  @if (policies.length === 0 && !defaultPolicy) {
    <div>
      <app-no-data [tableNotFoundText]="'policyPage.noPoliciesFoundMsg' | labelsProvider"></app-no-data>
    </div>
  }

  <div class="policies">
    @if (defaultPolicy) {
      <div class="policies-content-default-policy">
        <app-policy-box [policyModel]="defaultPolicy" (policyHandle)="policyClicked($event)"> </app-policy-box>
      </div>
    }

    @if (policies.length > 0) {
      <div class="more-policies">
        {{ 'policyPage.morePolicies' | labelsProvider }}
      </div>
    }

    @for (policy of policies; track policy) {
      <ng-container>
        @if (!policy.isDefault) {
          <app-policy-box
            [policyModel]="policy"
            (policyHandle)="policyClicked($event)"
            (deletePolicyHandle)="deleteCustomPolicy($event)"
            (duplicatePolicyHandle)="duplicatePolicyClicked($event)"
            [reachedMaxNumberOfPolicies]="reachedMaxNumberOfPolicies"
            [canAddOrDelete]="canAddOrDeletePolicy"
          >
          </app-policy-box>
        }
      </ng-container>
    }
  </div>
}
